
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export const InviteLoadingView = () => {
  const { t } = useTranslation();
  
  return (
    <div className="flex flex-1 items-center justify-center p-4">
      <Card className="w-full max-w-md border-gray-200 shadow-lg">
        <CardContent className="flex flex-col items-center justify-center py-10">
          <div className="relative mb-4">
            <Loader2 className="h-12 w-12 animate-spin text-primary" />
          </div>
          <p className="text-muted-foreground">{t('groupInvite.loading')}</p>
        </CardContent>
      </Card>
    </div>
  );
};
